import { ClientGateway } from "@kex/api";

import type { RequisitesMessage } from "./types";

import { getRequisitesDetailsMessages as getKyrgyzstanDetailsMessages } from "./kyrgyzstan";
import { getRequisitesDetailsMessages as getRussianRequisitesDetailsMessages } from "./russian";

export type RequisitesDetailsAccount = {
  country: ClientGateway.BankAccountCountryEnum;
  details: ClientGateway.BankAccountDetailsModel;
  name: string;
};

export const getRequisitesDetailsMessages = (
  clientType: ClientGateway.ClientTypesEnum,
  account: RequisitesDetailsAccount,
): RequisitesMessage[] => {
  if (account.country === "RUSSIA") {
    return getRussianRequisitesDetailsMessages(
      clientType,
      account.details as ClientGateway.BankAccountDetailsRussiaModel,
      account.name,
    );
  }
  if (account.country === "KYRGYZSTAN") {
    return getKyrgyzstanDetailsMessages(
      clientType,
      account.details as ClientGateway.BankAccountDetailsKyrgyzstanModel,
      account.name,
    );
  }

  return [];
};
